var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg-icon',{style:(_vm.svgStyle),attrs:{"icon-class":"explicit"}})
}
var staticRenderFns = []

export { render, staticRenderFns }